import { CloseIcon } from '@panwds/icons';
import { classNames } from '@panwds/tailwindcss';
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import '../Icon/ImgIcon.esm.js';
import { InfoIcon, WarningIcon, DangerIcon, SuccessIcon } from '../Icon/SemanticIcons.esm.js';
import { Body } from '../Typography/Body.esm.js';
import '@popperjs/core';
import '../../utils/constants.esm.js';
import 'react-dom';

const icons = {
    clear: null,
    info: React.createElement(InfoIcon, null),
    warning: React.createElement(WarningIcon, null),
    error: React.createElement(DangerIcon, null),
    success: React.createElement(SuccessIcon, null)
};
const Toast = forwardRef(({ children, appearance, remove, progress, text }, ref) => {
    const intl = useIntl();
    const message = Array.isArray(text) ? text : [text];
    return (React.createElement("div", { className: "tw-pt-4 tw-pr-4", ref: ref },
        React.createElement("div", { "data-testid": "toast", role: "alert", className: classNames('tw-w-80 tw-p-4 tw-relative tw-overflow-hidden', 'tw-bg-black tw-text-dark-bg', 'tw-flex tw-flex-col tw-gap-y-4 tw-rounded tw-shadow-toast dark:tw-shadow-toast-dark') },
            React.createElement("div", { className: "tw-flex tw-flex-row" },
                icons[appearance] && React.createElement("div", null, icons[appearance]),
                React.createElement("div", { className: classNames('tw-flex-grow tw-space-y-1 tw-min-w-0', appearance !== 'clear' && 'tw-ml-2') }, message.map((paragraph) => (React.createElement(Body, { key: paragraph, size: "sm", addClassName: "tw-text-gray-100 tw-break-words" }, paragraph)))),
                React.createElement("button", { "aria-label": intl.formatMessage({
                        defaultMessage: 'Close',
                        id: 'atoMCu',
                        description: 'Closes/removes system message'
                    }), className: "tw-text-blue-100 tw-border-none tw-bg-transparent hover:tw-text-disabled tw-p-0 tw-ml-4", onClick: remove, type: "button" },
                    React.createElement(CloseIcon, { size: "xs", className: "tw-mt-1" }))),
            children,
            progress)));
});
Toast.displayName = 'Toast';

export { Toast };
//# sourceMappingURL=Toast.esm.js.map
